import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qk6d1qkU1PDbDUUpyggcRc/Screenshot_2026-03-17_at_3.13.55_PM.png';
// Set page title
document.title = 'Emilius Pizza · Pizzería & Restaurante';
// Ensure proper mobile viewport
let viewport = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;
if (!viewport) {
  viewport = document.createElement('meta');
  viewport.name = 'viewport';
  document.head.appendChild(viewport);
}
viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
// Set theme color for mobile browser chrome
let themeColor = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
if (!themeColor) {
  themeColor = document.createElement('meta');
  themeColor.name = 'theme-color';
  document.head.appendChild(themeColor);
}
themeColor.content = '#0D0D0F';
// Set favicon
const existingFavicon = document.querySelector('link[rel="icon"]');
if (existingFavicon) existingFavicon.remove();
const favicon = document.createElement('link');
favicon.rel = 'icon';
favicon.type = 'image/png';
favicon.href = LOGO_URL;
document.head.appendChild(favicon);
const appleIcon = document.createElement('link');
appleIcon.rel = 'apple-touch-icon';
appleIcon.href = LOGO_URL;
document.head.appendChild(appleIcon);
// OG meta tags
const metaTags = [{
  property: 'og:title',
  content: 'Emilius Pizza · Pizzería & Restaurante'
}, {
  property: 'og:description',
  content: 'Pizzería & Restaurante 🚀 Pedí en línea'
}, {
  property: 'og:image',
  content: LOGO_URL
}, {
  property: 'og:image:width',
  content: '512'
}, {
  property: 'og:image:height',
  content: '512'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:site_name',
  content: 'Emilius Pizza'
}];
metaTags.forEach(({
  property,
  content
}) => {
  let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.content = content;
});
// Preconnect to image CDN for faster loading
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnect);
render(<App data-id="element-1705" />, document.getElementById('root'));